import { Tabs, ConfigProvider } from 'antd';
import React from 'react';
import Performenace from './Performenace';
import Social from './Social';


const items = [
    {
        key: '1',
        label: 'ESG Performance',
        children: (<Performenace />),
    },
    {
        key: '2',
        label: 'Social',
        children: (<Social />),
    },
    {
        key: '3',
        label: 'Governance',
        disabled: true,
    },
    {
        key: '4',
        label: 'Company Emissions',
        disabled: true,
    },
    {
        key: '5',
        label: 'Area Emission',
        disabled: true,
    },
    {
        key: '6',
        label: 'Site Emission',
        disabled: true,
    },
    {
        key: '7',
        label: 'Company Water Report',
        disabled: true,
    },
];

const onChange = (key) => {
    console.log(key);
};

export default function ESG() {
    return (
       
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
       
    );
}
